import React from "react";

const FPUMissionsContent = () => {
  const missions = [
    {
      name: "UNTAG",
      fullName: "United Nations Transition Assistance Group",
      location: "Namibia",
      period: "1989",
      personnel: { polki: 34, polwan: 0, total: 34 },
      status: "Selesai",
      type: "IPO",
    },
    {
      name: "UNTAC",
      fullName: "United Nations Transitional Authority in Cambodia",
      location: "Kamboja",
      period: "1992-1993",
      personnel: { polki: 307, polwan: 0, total: 307 },
      status: "Selesai",
      type: "IPO",
    },
    {
      name: "UNPROFOR",
      fullName: "United Nations Protection Force",
      location: "Kroasia",
      period: "1994",
      personnel: { polki: 15, polwan: 0, total: 15 },
      status: "Selesai",
      type: "IPO",
    },
    {
      name: "UNIMBH",
      fullName: "United Nations Mission in Bosnia and Herzegovina",
      location: "Bosnia",
      period: "1995-2001",
      personnel: { polki: 133, polwan: 3, total: 136 },
      status: "Selesai",
      type: "IPO",
    },
    {
      name: "UNMISS",
      fullName: "United Nations Mission in South Sudan",
      location: "Sudan Selatan",
      period: "2007-2010",
      personnel: { polki: 33, polwan: 3, total: 36 },
      status: "Selesai",
      type: "IPO",
    },
    {
      name: "MINUSCA",
      fullName:
        "United Nations Multidimensional Integrated Stabilization Mission in CAR",
      location: "Afrika Tengah",
      period: "2014-Sekarang",
      personnel: { polki: 120, polwan: 20, total: 140 },
      status: "Aktif",
      type: "FPU",
    },
  ];

  const missionsByDecade = {
    "1980s": missions.filter((m) => m.period.includes("1989")),
    "1990s": missions.filter((m) => m.period.includes("199")),
    "2000s": missions.filter((m) => m.period.includes("200")),
    "2010s": missions.filter((m) => m.period.includes("201")),
  };

  return (
    <div className="p-8">
      <div className="space-y-8">
        {/* Mission Overview */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">
            Daftar Misi Internasional Polri
          </h2>
          <p className="leading-relaxed text-base-content/70 mb-6">
            Polri telah berpartisipasi dalam berbagai misi pemeliharaan
            perdamaian PBB sejak 1989, berkontribusi sebagai Individual Police
            Officer (IPO) dan Formed Police Unit (FPU) di berbagai wilayah
            konflik di dunia.
          </p>

          {/* Statistics Cards */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="bg-primary/10 rounded-lg p-4 text-center border-2 border-primary/20">
              <div className="text-2xl mb-2">🌍</div>
              <h3 className="font-semibold">Total Misi</h3>
              <p className="text-primary font-bold text-xl">
                {missions.length}
              </p>
            </div>
            <div className="bg-secondary/10 rounded-lg p-4 text-center border-2 border-secondary/20">
              <div className="text-2xl mb-2">👮‍♂️</div>
              <h3 className="font-semibold">Total Personel</h3>
              <p className="text-secondary font-bold text-xl">
                {missions.reduce((sum, m) => sum + m.personnel.total, 0)}
              </p>
            </div>
            <div className="bg-accent/10 rounded-lg p-4 text-center border-2 border-accent/20">
              <div className="text-2xl mb-2">🏃‍♀️</div>
              <h3 className="font-semibold">Polwan</h3>
              <p className="text-accent font-bold text-xl">
                {missions.reduce((sum, m) => sum + m.personnel.polwan, 0)}
              </p>
            </div>
            <div className="bg-success/10 rounded-lg p-4 text-center border-2 border-success/20">
              <div className="text-2xl mb-2">✅</div>
              <h3 className="font-semibold">Misi Aktif</h3>
              <p className="text-success font-bold text-xl">
                {missions.filter((m) => m.status === "Aktif").length}
              </p>
            </div>
          </div>
        </div>

        {/* Missions by Decade */}
        <div className="space-y-6">
          {Object.entries(missionsByDecade).map(
            ([decade, missionList]) =>
              missionList.length > 0 && (
                <div key={decade} className="bg-base-200 rounded-xl p-6">
                  <h3 className="text-xl font-bold mb-4">{decade}</h3>
                  <div className="grid gap-4">
                    {missionList.map((mission, index) => (
                      <div key={index} className="bg-base-100 rounded-lg p-4">
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                          <div className="flex-1">
                            <div className="flex items-center gap-3 mb-2">
                              <h4 className="font-bold text-lg">
                                {mission.name}
                              </h4>
                              <span
                                className={`badge ${
                                  mission.status === "Aktif"
                                    ? "badge-success"
                                    : "badge-ghost"
                                }`}
                              >
                                {mission.status}
                              </span>
                              <span
                                className={`badge ${
                                  mission.type === "FPU"
                                    ? "badge-secondary"
                                    : "badge-accent"
                                }`}
                              >
                                {mission.type}
                              </span>
                            </div>
                            <p className="text-sm text-base-content/70 mb-1">
                              {mission.fullName}
                            </p>
                            <div className="flex items-center gap-4 text-sm">
                              <span className="flex items-center gap-1">
                                <span className="text-base-content/50">📍</span>
                                {mission.location}
                              </span>
                              <span className="flex items-center gap-1">
                                <span className="text-base-content/50">📅</span>
                                {mission.period}
                              </span>
                            </div>
                          </div>

                          <div className="flex gap-2">
                            <div className="bg-base-200 rounded-lg px-3 py-2 text-center">
                              <p className="text-xs text-base-content/50">
                                Polki
                              </p>
                              <p className="font-bold">
                                {mission.personnel.polki}
                              </p>
                            </div>
                            <div className="bg-base-200 rounded-lg px-3 py-2 text-center">
                              <p className="text-xs text-base-content/50">
                                Polwan
                              </p>
                              <p className="font-bold">
                                {mission.personnel.polwan}
                              </p>
                            </div>
                            <div className="bg-primary/20 rounded-lg px-3 py-2 text-center">
                              <p className="text-xs text-base-content/50">
                                Total
                              </p>
                              <p className="font-bold text-primary">
                                {mission.personnel.total}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ),
          )}
        </div>

        {/* Mission Types Comparison */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Perbandingan Tipe Misi</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-base-100 rounded-lg p-6">
              <h3 className="font-semibold text-lg mb-4 flex items-center gap-2">
                <span className="text-2xl">👮‍♂️</span>
                Individual Police Officer (IPO)
              </h3>
              <div className="space-y-3">
                <div className="flex justify-between">
                  <span>Jumlah Misi:</span>
                  <span className="font-bold">
                    {missions.filter((m) => m.type === "IPO").length}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span>Total Personel:</span>
                  <span className="font-bold">
                    {missions
                      .filter((m) => m.type === "IPO")
                      .reduce((sum, m) => sum + m.personnel.total, 0)}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span>Periode:</span>
                  <span className="font-bold">1989-2010</span>
                </div>
              </div>
              <div className="mt-4 p-3 bg-accent/10 rounded-lg">
                <p className="text-sm text-base-content/70">
                  Penugasan individual sebagai penasihat dan pembina kepolisian
                  lokal
                </p>
              </div>
            </div>

            <div className="bg-base-100 rounded-lg p-6">
              <h3 className="font-semibold text-lg mb-4 flex items-center gap-2">
                <span className="text-2xl">👥</span>
                Formed Police Unit (FPU)
              </h3>
              <div className="space-y-3">
                <div className="flex justify-between">
                  <span>Jumlah Misi:</span>
                  <span className="font-bold">
                    {missions.filter((m) => m.type === "FPU").length}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span>Total Personel:</span>
                  <span className="font-bold">
                    {missions
                      .filter((m) => m.type === "FPU")
                      .reduce((sum, m) => sum + m.personnel.total, 0)}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span>Periode:</span>
                  <span className="font-bold">2014-Sekarang</span>
                </div>
              </div>
              <div className="mt-4 p-3 bg-secondary/10 rounded-lg">
                <p className="text-sm text-base-content/70">
                  Unit terorganisir untuk operasi keamanan dan perlindungan
                  masyarakat sipil
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Geographic Distribution */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Distribusi Geografis Misi</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              { region: "Afrika", missions: ["MINUSCA"], icon: "🌍" },
              { region: "Asia", missions: ["UNTAG", "UNTAC"], icon: "🗺️" },
              {
                region: "Eropa",
                missions: ["UNPROFOR", "UNIMBH", "UNTAES", "UNIPTF"],
                icon: "🏰",
              },
              { region: "Timur Tengah", missions: ["UNAMA"], icon: "🏜️" },
            ].map((region, index) => (
              <div
                key={index}
                className="bg-base-100 rounded-lg p-4 text-center"
              >
                <div className="text-3xl mb-2">{region.icon}</div>
                <h3 className="font-semibold text-lg mb-2">{region.region}</h3>
                <p className="text-primary font-bold text-xl mb-2">
                  {region.missions.length}
                </p>
                <div className="text-sm text-base-content/70">
                  {region.missions
                    .map(
                      (m) =>
                        missions.find((mission) => mission.name === m)
                          ?.location,
                    )
                    .join(", ")}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Current Active Mission Highlight */}
        <div className="bg-gradient-to-r from-primary/20 to-secondary/20 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Misi Aktif Saat Ini</h2>
          {missions
            .filter((m) => m.status === "Aktif")
            .map((mission, index) => (
              <div key={index} className="bg-base-100 rounded-lg p-6">
                <div className="flex items-center gap-4 mb-4">
                  <div className="text-4xl">🇨🇫</div>
                  <div>
                    <h3 className="text-xl font-bold">{mission.name}</h3>
                    <p className="text-base-content/70">{mission.fullName}</p>
                  </div>
                  <div className="ml-auto">
                    <span className="badge badge-success">Aktif</span>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
                  <div className="text-center">
                    <p className="font-semibold">Lokasi</p>
                    <p className="text-base-content/70">{mission.location}</p>
                  </div>
                  <div className="text-center">
                    <p className="font-semibold">Periode</p>
                    <p className="text-base-content/70">{mission.period}</p>
                  </div>
                  <div className="text-center">
                    <p className="font-semibold">Tipe Misi</p>
                    <p className="text-secondary font-bold">{mission.type}</p>
                  </div>
                  <div className="text-center">
                    <p className="font-semibold">Total Personel</p>
                    <p className="text-primary font-bold">
                      {mission.personnel.total}
                    </p>
                  </div>
                </div>

                <div className="bg-base-200 rounded-lg p-4">
                  <h4 className="font-semibold mb-2">Komposisi Personel:</h4>
                  <div className="flex gap-4">
                    <span>
                      Polki: <strong>{mission.personnel.polki}</strong>
                    </span>
                    <span>
                      Polwan: <strong>{mission.personnel.polwan}</strong>
                    </span>
                    <span>
                      Total:{" "}
                      <strong className="text-primary">
                        {mission.personnel.total}
                      </strong>
                    </span>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default FPUMissionsContent;
